import styled from 'styled-components';

/** The design's `.avatar` — ink ground, white initials, always a circle. */
export const Avatar = styled.div`
  display: grid;
  place-items: center;
  width: var(--h-avatar);
  height: var(--h-avatar);
  flex: 0 0 var(--h-avatar);
  overflow: hidden;
  border-radius: var(--r-pill);
  background: var(--ink-700);
  font-family: var(--font-ui);
  font-size: var(--fs-th);
  font-weight: var(--fw-semibold);
  line-height: 1;
  color: var(--text-invert);
  user-select: none;

  &.lg {
    width: var(--h-avatar-lg);
    height: var(--h-avatar-lg);
    flex-basis: var(--h-avatar-lg);
    font-size: var(--fs-label);
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
